// extracted by mini-css-extract-plugin
export var attachment = "_nu-a";
export var emailContainer = "_nu-4";
export var emailContentPaddedContainer = "_nu-b";
export var emailHeader = "_nu-6";
export var emailIframe = "_nu-3";
export var emailInfoIcon = "_nu-9";
export var emailShortenedSummary = "_nu-e";
export var infoDropdown = "_nu-0";
export var infoRowBoundedContent = "_nu-d";
export var internal = "_nu-5";
export var merchant = "_nu-8";
export var messageInputContainer = "_nu-h";
export var normal = "_nu-7";
export var replyCard = "_nu-f";
export var subtleButton = "_nu-1";
export var subtleButtonIconContainer = "_nu-2";
export var toggleViewRepliesButton = "_nu-c";
export var wrappingText = "_nu-g";